import React from 'react';

export default function RefundAnalyticsOverview() {
  return <div>RefundAnalyticsOverview</div>;
}
